import { render, staticRenderFns } from "./About.vue?vue&type=template&id=2e5440ee&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&lang=css&"
import style1 from "./About.vue?vue&type=style&index=1&id=2e5440ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5440ee",
  null
  
)

export default component.exports